(function(){
  var nav = document.querySelector('.nav');
  function onScroll(){ if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Titular del hero: cada palabra sube por separado
  var title = document.querySelector('.template-index .hero-title');
  if (title && !title.querySelector('.w')) {
    var text = title.textContent.trim();
    title.setAttribute('aria-label', text);
    title.textContent = '';
    text.split(/\s+/).forEach(function(word, i){
      var outer = document.createElement('span');
      var inner = document.createElement('span');
      outer.className = 'w';
      outer.setAttribute('aria-hidden', 'true');
      inner.style.setProperty('--i', i);
      inner.textContent = word;
      outer.appendChild(inner);
      title.appendChild(outer);
      title.appendChild(document.createTextNode(' '));
    });
  }

  // Parallax suave de la foto del hero
  var media = document.querySelector('.template-index .hero-media');
  if (media && window.innerWidth > 768) {
    var ticking = false;
    window.addEventListener('scroll', function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        media.style.transform = 'translateY(' + Math.min(window.scrollY * 0.08, 60) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }
})();
